import { Order } from '@porterin/booking-flow/src/order-history/domain/entities/OrderHistory';
import { OrderType } from '@porterin/booking-flow/src/order-history/domain/entities/OrderType';
import { Loadable } from '@porterin/booking-flow/src/order-review/view/types/Loadable';
import { AppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/AppConfig';
import { getAppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/FetchConfig';
import { getLocaleCookie } from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';
const Config: AppConfig = getAppConfig();

export const countOfLiveOrder = (
  order_history: Loadable<Order[], any>,
): number => {
  if (order_history.state === 'Live') {
    return order_history.data.length;
  }
  return 0;
};

export const orderCrn = (history: Loadable<Order[], any>, index: number) => {
  switch (history.state) {
    case 'Live':
      return history.data.length > 0 ? history.data[index].orderCrn : '';
    default:
      return '';
  }
};

export const isCourierOrder = (
  history: Loadable<Order[], any>,
  index: number,
): boolean => {
  if (history.state === 'Live') {
    return (
      history.data.length > 0 && history.data[index].type === OrderType.Courier
    );
  }
  return false;
};

export const orderHistoryLinkRedirect = () => {
  window.location.href = `/${getLocaleCookie()}/order-history`;
};

export const allocationLinkRedirect = (crn: string) => {
  window.location.href = `/${getLocaleCookie()}/track-order?crn=${crn}`;
};

export const courierTrackingLinkRedirect = (crn: string) => {
  window.location.href = `${Config.newInitiativesUrl}track-courier-order?source=website&crn=${crn}`;
};
